import { createSlice } from '@reduxjs/toolkit'

export const bookingSlice = createSlice({
    name: 'bookings',
    initialState: {
        bookings: [],
    },
    reducers: {
        load: (state, action) => {
            state.bookings = action.payload
        },
    }
})
export default bookingSlice.reducer

export const { load } = bookingSlice.actions

export const getAllBookings = (state) => state.bookings.bookings || [];
